import type { Localization, Topbar } from '@/payload-types'

/** Map normalized label (any locale) → canonical `navbar` key. */
const LABEL_ALIASES: Record<string, keyof Localization['navbar']> = {
  home: 'home',
  catalogue: 'catalogue',
  products: 'products',
  news: 'news',
  dealership: 'dealership',
  contact: 'contact',
  'contact us': 'contact us',
  'about us': 'about us',
  about: 'about',
  blog: 'blog',
  insight: 'insight',
  insights: 'insights',
  pricing: 'pricing',
  maison: 'home',
  produits: 'products',
  actualités: 'news',
  concession: 'dealership',
  connaissances: 'insights',
  'à propos': 'about',
  'à propos de nous': 'about us',
  'contactez-nous': 'contact us',
  tarifs: 'pricing',
}

export function resolveTopbarNavLabel(
  link: NonNullable<Topbar['navLinks']>[number],
  translatedData: Localization | null,
): string {
  const navKey = link.navKey

  if (navKey && navKey !== 'custom') {
    const k = navKey as keyof Localization['navbar']
    return translatedData?.navbar?.[k] ?? ''
  }

  const raw = typeof link.category === 'string' ? link.category.trim() : ''
  if (!raw) return ''

  const low = raw.toLowerCase()
  const fromAlias = LABEL_ALIASES[low]
  if (fromAlias && translatedData?.navbar?.[fromAlias]) {
    return translatedData.navbar[fromAlias]!
  }

  if (translatedData) {
    const n = translatedData.navbar?.[low as keyof typeof translatedData.navbar]
    if (n) return n
    const c = translatedData.common?.[low as keyof typeof translatedData.common]
    if (c) return c
  }

  return raw
}
